$(document).ready(function(){
  // mobile hamburger menu
  hamburger();
  // desktop sub menu
  desktopMenu();
  // aside nav
  sidebarNav();
});

function desktopMenu(){
  var button = $('.desktop-menu li.main-li a')
  var sub = $('.desktop-menu li.main-li .sub-menu')
  button.on('mouseenter', function(){
    $(this).next('.sub-menu').addClass('active');
  })
  sub.on('mouseleave', function(){
    $('.desktop-menu .sub-menu').removeClass('active');
  });
}

function hamburger(){
  var button = $('.hamburger');
  var mobile_content = $('.mobile-content');
  button.click(function(){
      button.toggleClass('is-active');
      mobile_content.toggleClass('is-active');
    $('.mobile-menu').toggleClass('is-active');
  });
}

function sidebarNav() {
  var button = $('.internal-navigation .aside-button');
  button.click(function(e) {
    e.preventDefault();
    
    var subMenu = $(this).next();
    if (subMenu.hasClass('active')) {
      $(this).removeClass('active');
      subMenu.removeClass('active');
    } else {
      $(this).addClass('active');
      $('.internal-navigation .sub-menu').removeClass('active');
      subMenu.addClass('active');
    }
  });
}
